import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import config from 'config';

import {
  getAccountAddress,
  getAccountBalance,
  getChainId,
  getNativeBalance,
} from 'modules/store';

export async function getApplicationData(
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
): Promise<void> {
  const { data: accountAddress = '' } = await dispatch(
    getAccountAddress.initiate(undefined, {
      subscribe: true,
      forceRefetch: true,
    }),
  );

  const { data: chainId } = await dispatch(
    getChainId.initiate(undefined, {
      subscribe: true,
      forceRefetch: true,
    }),
  );

  if (!chainId || !config[chainId]) {
    return;
  }

  await Promise.all([
    dispatch(
      getAccountBalance.initiate(
        { accountAddress },
        {
          subscribe: true,
          forceRefetch: true,
        },
      ),
    ),
    dispatch(
      getNativeBalance.initiate(
        { accountAddress },
        {
          subscribe: true,
          forceRefetch: true,
        },
      ),
    ),
  ]);
}
